import { getErrorCodeFromUnknown } from "./ErrorParsers";

export enum AuthErrors {
  SignUpRequired = "auth/sign-up-required",
  MigrationRequired = "auth/migration-required",
  EmailNotVerified = "auth/email-not-verified",
}

const authErrorCodes = new Set<string>(Object.values(AuthErrors));

export function getAuthErrorCode(error: unknown): AuthErrors | undefined {
  const errorCode = getErrorCodeFromUnknown(error);
  if (!errorCode || !authErrorCodes.has(errorCode)) {
    return undefined;
  }

  return errorCode as AuthErrors;
}
